export const translations = {
	milliseconds: {},
	seconds: {},
	minutes: {},
	hours: {},
};
